/**
 * POR HACER
 * Evitar que los click se propaguen debajo de los botones de acción
 * En la vista de móvil se cierra el modal del producto cuando doy click en cerrar notificación
 */

import React, { useState } from 'react';
import Button from '@mui/material/Button';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Notifications({ open, message, severity = 'info', setOpen = null, actions = null}) {

  const handleClose = () => {
    if(setOpen){
      setOpen(false);
    }
    
  };

  const action = (
    <React.Fragment>
      {
        actions? actions : <></>
      }
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <Snackbar 
      disableWindowBlurListener={false}
      anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
      open={open} 
      autoHideDuration={5000} 
      onClose={handleClose}
      sx={{maxWidth:'85vw'}}
    >
        
      <Alert 
        className = 'interactable-ui'
        action={action}
        // onClose={handleClose} 
        severity={severity} 
        sx={{ width: '100%' , display:'flex', justifyContent:'center', alignItems: 'center'}}
      >
        {message}
      </Alert>

    </Snackbar>
  );
}